module.exports = __webpack_public_path__ + "img/logo-small.27ee885e.svg";